import { useEffect,useState,useContext } from 'react'
import { useNavigate,useParams } from 'react-router-dom'
import { Alert, Box, Card, CardContent, Fade, FormControlLabel, Grid, List, ListItemButton, ListItemIcon, ListItemText, Modal, Radio, RadioGroup, Switch, TextField, Typography } from '@mui/material'
import { post } from '../../utils/axios'
import Button from '../../components/Button'
import { toast } from 'react-toastify'
import { Context } from '../../context/Context'
import { CheckCircleOutline } from '@mui/icons-material'
import * as SignalR from '@microsoft/signalr'

import './Confirm.css'

const Confirm = () => {

    const navigate = useNavigate()
    const context = useContext(Context)

    const {orderId,repay} = useParams()
    const [isFetchedData,setIsFetchedData] = useState(false)
    const [businessId,setBusinessId] = useState(0)
    const [businessCityId,setBusinessCityId] = useState(0)
    const [openDeposit,setOpenDeposit] = useState(false)
    const [amount,setAmount] = useState('')
    const [gatewayId,setGatewayId] = useState(0)
    const [gateways,setGateways] = useState([])
    const [isLoading,setIsLoading] = useState(true)
    const [sentOtp,setSentOtp] = useState(false)
    const [otpCounter,setOtpCounter] = useState('')
    const [orderIsLoading,setOrderIsLoading] = useState(false)
    const [otp,setOtp] = useState('')
    const [consumerId,setConsumerId] = useState(0)
    const [addressId,setAddressId] = useState(0)
    const [addresses,setAddresses] = useState([])
    const [deliveryType,setDeliveryType] = useState(0)
    const [delivery,setDelivery] = useState(0)
    const [totalPrice,setTotalPrice] = useState(0)
    const [walletIncrease,setWalletIncrease] = useState(0)
    const [hasCredit,setHasCredit] = useState(false)
    const [hasCreditWithWallet,setHasCreditWithWallet] = useState(false)
    const [useWallet,setUseWallet] = useState(false)
    const [guildId,setGuildId] = useState()
    const [rules,setRules] = useState()
    const [userDetails,setUserDetails] = useState({
        firstName: '',
        lastName: '',
        mobile: '',
        nationalCode: '',
        insuranceNo: '',
        description: ''
    })
    const [additionalInfo,setAdditionalInfo] = useState([])
    const [btnText,setBtnText] = useState('دریافت رمز')
    const [connection,setConnection] = useState()
    const [allowOrder,setAllowOrder] = useState(true)
    const [forAnother,setForAnother] = useState(false)
    const [acceptTerms,setAcceptTerms] = useState(false)
    const [openRules,setOpenRules] = useState(false)
    
    useEffect(() => {
        const signalRConnection = new SignalR.HubConnectionBuilder().withUrl('https://petromah.sabinarya.com/service/petroHub').withAutomaticReconnect().build()
        setConnection(signalRConnection)
    },[])

    useEffect(() => {
        if(connection){
            connection.start()
        }
    },[connection])

    useEffect(() => {
        const addInfo = []
        if(userDetails.firstName)
            addInfo.push({key: 'firstName',value: userDetails.firstName})
        if(userDetails.lastName)
            addInfo.push({key: 'lastName',value: userDetails.lastName})
        if(userDetails.mobile)
            addInfo.push({key: 'mobile',value: userDetails.mobile})
        if(userDetails.nationalCode)
            addInfo.push({key: 'nationalCode',value: userDetails.nationalCode})
        if(userDetails.insuranceNo)
            addInfo.push({key: 'insuranceNo',value: userDetails.insuranceNo})
        if(userDetails.description)
            addInfo.push({key: 'description',value: userDetails.description})
        if(addInfo.length)
            setAdditionalInfo(addInfo)
    },[userDetails])

    const getData = async () => {
        let totalPrice = 0
        let businessId = 0
        if(!orderId){
            post('Address/GetAllAddressByPersonId').then(({data}) => {
                if(data.isSuccess){
                    setAddresses(data.data)
                    if(context.address.id)
                        setAddressId(context.address.id)
                    else if(data.data[0])
                        setAddressId(data.data[0].id)
                }
            }).finally(() => {
                setDeliveryType(context.basket[0].deliverType)
                setDelivery(context.basket[0].deliverType == 2 || context.basket[0].deliverType == 3 ? 1 : 0)
                setGuildId(context.basket[0].guildId)
            })
            context.basket.map(item => totalPrice += item.price)
            businessId = context.basket[0].businessId
            setBusinessId(businessId)
            setBusinessCityId(context.basket[0].cityId)
            setRules(context.basket[0].rule)
        }else{
            let itemId = 0
            const getOrderPosteData = {
                serviceConsumerId: orderId
            }
            await post('Order/GetOrder',getOrderPosteData).then(({data}) => {
                if(data.isSuccess){
                    businessId = data.data.businessId
                    setBusinessId(businessId)
                    data.data.subServiceId.map(item => totalPrice += item.price)
                    itemId = data.data.subServiceId[0].id
                }else{
                    toast.error(data.message)
                    navigate('/app')
                }
            })
            await post('Business/GetBusinessById',{id: businessId}).then(({ data }) => {
                if(data.isSuccess){
                    setGuildId(data.data.guildId)
                    setBusinessCityId(data.data.cityId)
                    setRules(data.data.rule)
                }
            })
            if(repay && repay == 'repay'){
                await post('SubService/GetSubservicesByBusinessId',{businessId}).then(({ data }) => {
                    if(data.isSuccess && data.data.length){
                        const serviceItem = data.data.find(item => item.id == itemId)
                        setDeliveryType(serviceItem.deliverType)
                        setDelivery(serviceItem.deliverType == 2 || serviceItem.deliverType == 3 ? 1 : 0)
                    }
                })
            }
        }
        const postedData = {
            businessId,
            amount: totalPrice
        }
        setTotalPrice(totalPrice)
        if(context.profile.roleId != 103){
            post('Payment/ValidatePay',postedData).then(({data}) => {
                if(data && data.data && Object.keys(data.data).length){
                    if(data.data.isSegmentBalanceForPay)
                        setHasCredit(true)
                    if(data.data.isSumBalanceForPay)
                        setHasCreditWithWallet(true)
                    else{
                        post('Payment/GetActiveGateway').then(({ data }) => {
                            if(data.isSuccess){
                                setGateways(data.data)
                                setGatewayId(data.data[0].id)
                            }
                        })
                    }
                    setWalletIncrease(data.data.walletIncrease)
                    setAmount(new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(data.data.walletIncrease || 0))
                }
            }).finally(() => {
                setIsLoading(false)
                setIsFetchedData(true)
            })
        }else{
            post('Payment/ValidatePayChild',postedData).then(({data}) => {
                if(data && data.data && Object.keys(data.data).length){
                    if(data.data.isSegmentBalanceForPay)
                        setHasCredit(true)
                    setWalletIncrease(null)
                    setAmount(null)
                }
            }).finally(() => {
                setIsLoading(false)
                setIsFetchedData(true)
            })
        }
    }

    useEffect(() => {
        if(addressId && businessCityId && delivery == 1){
            const address = addresses.find(addr => addr.id == addressId)
            if(address && address.cityId != businessCityId)
                setAllowOrder(false)
            else
                setAllowOrder(true)
        }
    },[addressId,delivery,businessCityId])

    useEffect(() => {
        if(!context.basket.length && !orderId)
            return navigate('/app')
        getData()
    },[])

    const checkPersianCharacters = str => /^[\u0600-\u06FF\s]+$/.test(str)

    useEffect(() => {
        if(userDetails.mobile && userDetails.mobile.length){
            if(userDetails.mobile.includes('۰'))
                setUserDetails({...userDetails,mobile: userDetails.mobile.replace(/۰/g,'0')})
            if(userDetails.mobile.includes('۱'))
                setUserDetails({...userDetails,mobile: userDetails.mobile.replace(/۱/g,'1')})
            if(userDetails.mobile.includes('۲'))
                setUserDetails({...userDetails,mobile: userDetails.mobile.replace(/۲/g,'2')})
            if(userDetails.mobile.includes('۳'))
                setUserDetails({...userDetails,mobile: userDetails.mobile.replace(/۳/g,'3')})
            if(userDetails.mobile.includes('۴'))
                setUserDetails({...userDetails,mobile: userDetails.mobile.replace(/۴/g,'4')})
            if(userDetails.mobile.includes('۵'))
                setUserDetails({...userDetails,mobile: userDetails.mobile.replace(/۵/g,'5')})
            if(userDetails.mobile.includes('۶'))
                setUserDetails({...userDetails,mobile: userDetails.mobile.replace(/۶/g,'6')})
            if(userDetails.mobile.includes('۷'))
                setUserDetails({...userDetails,mobile: userDetails.mobile.replace(/۷/g,'7')})
            if(userDetails.mobile.includes('۸'))
                setUserDetails({...userDetails,mobile: userDetails.mobile.replace(/۸/g,'8')})
            if(userDetails.mobile.includes('۹'))
                setUserDetails({...userDetails,mobile: userDetails.mobile.replace(/۹/g,'9')})
        }
    },[userDetails.mobile])

    useEffect(() => {
        if(userDetails.nationalCode && userDetails.nationalCode.length){
            if(userDetails.nationalCode.includes('۰'))
                setUserDetails({...userDetails,nationalCode: userDetails.nationalCode.replace(/۰/g,'0')})
            if(userDetails.nationalCode.includes('۱'))
                setUserDetails({...userDetails,nationalCode: userDetails.nationalCode.replace(/۱/g,'1')})
            if(userDetails.nationalCode.includes('۲'))
                setUserDetails({...userDetails,nationalCode: userDetails.nationalCode.replace(/۲/g,'2')})
            if(userDetails.nationalCode.includes('۳'))
                setUserDetails({...userDetails,nationalCode: userDetails.nationalCode.replace(/۳/g,'3')})
            if(userDetails.nationalCode.includes('۴'))
                setUserDetails({...userDetails,nationalCode: userDetails.nationalCode.replace(/۴/g,'4')})
            if(userDetails.nationalCode.includes('۵'))
                setUserDetails({...userDetails,nationalCode: userDetails.nationalCode.replace(/۵/g,'5')})
            if(userDetails.nationalCode.includes('۶'))
                setUserDetails({...userDetails,nationalCode: userDetails.nationalCode.replace(/۶/g,'6')})
            if(userDetails.nationalCode.includes('۷'))
                setUserDetails({...userDetails,nationalCode: userDetails.nationalCode.replace(/۷/g,'7')})
            if(userDetails.nationalCode.includes('۸'))
                setUserDetails({...userDetails,nationalCode: userDetails.nationalCode.replace(/۸/g,'8')})
            if(userDetails.nationalCode.includes('۹'))
                setUserDetails({...userDetails,nationalCode: userDetails.nationalCode.replace(/۹/g,'9')})
        }
    },[userDetails.nationalCode])

    useEffect(() => {
        if(userDetails.insuranceNo && userDetails.insuranceNo.length){
            if(userDetails.insuranceNo.includes('۰'))
                setUserDetails({...userDetails,insuranceNo: userDetails.insuranceNo.replace(/۰/g,'0')})
            if(userDetails.insuranceNo.includes('۱'))
                setUserDetails({...userDetails,insuranceNo: userDetails.insuranceNo.replace(/۱/g,'1')})
            if(userDetails.insuranceNo.includes('۲'))
                setUserDetails({...userDetails,insuranceNo: userDetails.insuranceNo.replace(/۲/g,'2')})
            if(userDetails.insuranceNo.includes('۳'))
                setUserDetails({...userDetails,insuranceNo: userDetails.insuranceNo.replace(/۳/g,'3')})
            if(userDetails.insuranceNo.includes('۴'))
                setUserDetails({...userDetails,insuranceNo: userDetails.insuranceNo.replace(/۴/g,'4')})
            if(userDetails.insuranceNo.includes('۵'))
                setUserDetails({...userDetails,insuranceNo: userDetails.insuranceNo.replace(/۵/g,'5')})
            if(userDetails.insuranceNo.includes('۶'))
                setUserDetails({...userDetails,insuranceNo: userDetails.insuranceNo.replace(/۶/g,'6')})
            if(userDetails.insuranceNo.includes('۷'))
                setUserDetails({...userDetails,insuranceNo: userDetails.insuranceNo.replace(/۷/g,'7')})
            if(userDetails.insuranceNo.includes('۸'))
                setUserDetails({...userDetails,insuranceNo: userDetails.insuranceNo.replace(/۸/g,'8')})
            if(userDetails.insuranceNo.includes('۹'))
                setUserDetails({...userDetails,insuranceNo: userDetails.insuranceNo.replace(/۹/g,'9')})
        }
    },[userDetails.insuranceNo])

    useEffect(() => {
        if(otp && otp.length){
            if(otp.includes('۰'))
                setOtp(otp.replace(/۰/g,'0'))
            if(otp.includes('۱'))
                setOtp(otp.replace(/۱/g,'1'))
            if(otp.includes('۲'))
                setOtp(otp.replace(/۲/g,'2'))
            if(otp.includes('۳'))
                setOtp(otp.replace(/۳/g,'3'))
            if(otp.includes('۴'))
                setOtp(otp.replace(/۴/g,'4'))
            if(otp.includes('۵'))
                setOtp(otp.replace(/۵/g,'5'))
            if(otp.includes('۶'))
                setOtp(otp.replace(/۶/g,'6'))
            if(otp.includes('۷'))
                setOtp(otp.replace(/۷/g,'7'))
            if(otp.includes('۸'))
                setOtp(otp.replace(/۸/g,'8'))
            if(otp.includes('۹'))
                setOtp(otp.replace(/۹/g,'9'))
        }
    },[otp])

    const startCounter = () => {
        setOtpCounter(120)
        let interCounter = 120
        const interval = setInterval(() => {
            if(interCounter > 0){
                interCounter -= 1
                setOtpCounter(interCounter)
            }
            if(interCounter == 0){
                clearInterval(interval)
                setSentOtp(false)
            }
        },1000)
    }

    useEffect(() => {
        if(sentOtp)
            startCounter()
    },[sentOtp])

    const sendOtp = () => {
        setOtp('')
        setIsLoading(true)
        setBtnText('دریافت مجدد رمز')
        let subServiceId = []
        context.basket.map(item => subServiceId.push(item.id))
        const postedData = {
            subServiceId,
            businessId: businessId,
            shippingMethod: delivery == 1 ? 1 : 0
        }
        if(addressId)
            postedData.addressId = addressId
        if(additionalInfo.length && guildId && guildId != 64)
            postedData.additionalInfo = additionalInfo
        if(consumerId || orderId){
            post('Payment/SendOtpCodeCloseloop',{consumerId: consumerId || orderId}).then(({data}) => {
                if(data.isSuccess){
                    setSentOtp(true)
                    toast.success('رمز یکبار مصرف برای شما ارسال شد')
                }else
                    toast.error(data.message)
            }).finally(() => {
                setIsLoading(false)
            })
        }else{
            post('Order/AddOrder',postedData).then(({data}) => {
                if(data.isSuccess){
                    setConsumerId(data.data.serviceConsumerId)
                    post('Payment/SendOtpCodeCloseloop',{consumerId: data.data.serviceConsumerId}).then(({data}) => {
                        if(data.isSuccess){
                            setSentOtp(true)
                            toast.success('رمز یکبار مصرف برای شما ارسال شد')
                        }else
                            toast.error(data.message)
                    }).finally(() => {
                        setIsLoading(false)
                    })
                }else{
                    setIsLoading(false)
                    toast.error(data.message)
                }
            })
        }
    }

    const invokeNewOrder = orderId => {
        connection.invoke('sendOrder',orderId)
    }
    
    const submitOrder = () => {
        setOrderIsLoading(true)
        if(consumerId || orderId){
            const postedData = {
                consumerId: consumerId || orderId,
                otpCode: otp
            }
            post('Payment/PaybyCloseloop',postedData).then(({data}) => {
                if(data.isSuccess){
                    context.setBasket([])
                    toast.success('سفارش شما با موفقیت ثبت شد')
                    navigate(`/app/orders/${consumerId || orderId}`)
                    invokeNewOrder(consumerId || orderId)
                }else
                    toast.error(data.message)
            }).finally(() => {
                setOrderIsLoading(false)
            })
        }else{
            let subServiceId = []
            context.basket.map(item => subServiceId.push(item.id))
            const orderPostedData = {
                subServiceId,
                businessId,
                shippingMethod: delivery == 1 ? 1 : 0
            }
            if(addressId)
                orderPostedData.addressId = addressId
            if(additionalInfo.length)
                orderPostedData.additionalInfo = additionalInfo
            post('Order/AddOrder',orderPostedData).then(({data}) => {
                if(data.isSuccess){
                    setConsumerId(data.data.serviceConsumerId)
                    const paymentPostedData = {
                        consumerId: data.data.serviceConsumerId,
                        otpCode: otp
                    }
                    post('Payment/PaybyCloseloop',paymentPostedData).then(({data}) => {
                        if(data.isSuccess){
                            context.setBasket([])
                            toast.success('سفارش شما با موفقیت ثبت شد')
                            navigate(`/app/orders/${paymentPostedData.consumerId}`)
                            invokeNewOrder(paymentPostedData.consumerId)
                        }else
                            toast.error(data.message)
                    }).finally(() => {
                        setOrderIsLoading(false)
                    })
                }else{
                    setOrderIsLoading(false)
                    toast.error(data.message)
                }
            })
        }
    }

    const setNewAddressId = id => {
        setAddressId(id)
        if(id && businessCityId && delivery == 1){
            const address = addresses.find(addr => addr.id == id)
            if(address && address.cityId != businessCityId){
                toast.error('آدرس انتخابی برای این سفارش معتبر نمی‌باشد')
                setAllowOrder(false)
            }else
                setAllowOrder(true)
        }
    }

    const setAmountValue = value => {
        value = value.toString().replace(/,/g,'')
        value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value)
        if(value == 'NaN')
            value = '';
        setAmount(value)
    }

    const chargeDeposit = () => {
        setIsLoading(true)
        const postedData = {
            amount: amount.toString().replace(/,/g,''),
            gatewayId,
            action: 1
        }
        post('Payment/GetToken',postedData).then(({ data }) => {
            if(data.isSuccess)
                window.location.href = data.data.redirectUrl
            else
                setIsLoading(false)
        }).catch((e) => {
            setIsLoading(false)
        })
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '92%',
        boxSizing: 'border-box',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    }

    return (
        <Grid item px={0.3} sx={{position: 'relative'}}>
            <div className="safe-area">
                <Box sx={{mb: 3}}>
                    {deliveryType == 3 ? <h3 className="others-page-title">روش ارسال</h3> : ''}
                    {deliveryType == 3 ? <Card sx={{width: '100%',mb: 2.5}}>
                        <CardContent style={{paddingBottom: 14}}>
                            <RadioGroup defaultValue={delivery} name="delivery" value={delivery} onChange={e => setDelivery(e.target.value)}>
                                <FormControlLabel value={1} control={<Radio />} label="ارسال با پیک" />
                                <FormControlLabel value={0} control={<Radio />} label="مراجعه حضوری" />
                            </RadioGroup>
                        </CardContent>
                    </Card> : ''}
                    {delivery == 1 ? <h3 className="others-page-title">آدرس برای ارسال</h3> : ''}
                    {delivery == 1 ? <Card sx={{width: '100%',mb: 2.5}}>
                        <CardContent style={{paddingBottom: 10}}>
                            <Button variant="contained" color="secondary" sx={{mt: 0.5,mb: 1}} onClick={() => navigate('/app/profile/addresses/add')}>افزودن آدرس</Button>
                            <hr style={{height: 1,backgroundColor: 'rgb(210,210,210)',marginTop: 15,marginBottom: 10}} />
                            {addresses.length ? <RadioGroup defaultValue={addresses[0]?.id} name="address" value={addressId} onChange={e => setNewAddressId(e.target.value)}>
                                {addresses.map(address => <FormControlLabel sx={{mb: 1.5}} key={address.id} value={address.id} control={<Radio />} label={<div className="address-radio-label"><p>{address.title}</p><span>{address.address.length > 50 ? (address.address.slice(0,50) + ' ...') : address.address}</span></div>} />)}
                            </RadioGroup> : <Alert severity="info" sx={{mt: 2.5,mb: 1.5}}>آدرسی یافت نشد</Alert>}
                        </CardContent>
                    </Card> : ''}
                    {guildId != 204 && <><h3 className="others-page-title confirm-page-title">{guildId && guildId != 64 ? 'اطلاعات استفاده کننده' : 'توضیحات'}</h3>
                    <Card sx={{width: '100%',mb: 3}}>
                        <CardContent style={{paddingBottom: 10}}>
                            {guildId && guildId != 64 ? <FormControlLabel sx={{mb: forAnother ? 1 : 2}} control={<Switch checked={forAnother} onChange={() => setForAnother(!forAnother)} />} label="ثبت سفارش برای دیگری" /> : ''}
                            {guildId && guildId != 64 && forAnother ? <TextField fullWidth sx={{mt: 2,mb: 2}} className={!checkPersianCharacters(userDetails.firstName) ? 'has-validation-error' : ''} label="نام" variant="outlined" onChange={e => setUserDetails({...userDetails,firstName: e.target.value})} value={userDetails.firstName} /> : ''}
                            {guildId && guildId != 64 && forAnother ? <TextField fullWidth sx={{mb: 2}} className={!checkPersianCharacters(userDetails.lastName) ? 'has-validation-error' : ''} label="نام خانوادگی" variant="outlined" onChange={e => setUserDetails({...userDetails,lastName: e.target.value})} value={userDetails.lastName} /> : ''}
                            {guildId && guildId != 64 && forAnother ? <TextField fullWidth sx={{mb: 2}} inputProps={{dir: 'ltr',maxLength: 11,className: userDetails.mobile && (!/^\d+$/.test(userDetails.mobile) || userDetails.mobile.length != 11) ? 'has-validation-error' : ''}} label="موبایل" type="tel" variant="outlined" onChange={e => setUserDetails({...userDetails,mobile: e.target.value})} value={userDetails.mobile} /> : ''}
                            {guildId && guildId != 64 && forAnother ? <TextField fullWidth sx={{mb: 2}} inputProps={{dir: 'ltr',maxLength: 10,className: userDetails.nationalCode && (!/^\d+$/.test(userDetails.nationalCode) || userDetails.nationalCode.length != 10) ? 'has-validation-error' : ''}} label="کد ملی" type="tel" variant="outlined" onChange={e => setUserDetails({...userDetails,nationalCode: e.target.value})} value={userDetails.nationalCode} /> : ''}
                            {guildId && guildId == 43 ? <TextField fullWidth sx={{mb: 2.1}} label="شماره بیمه" inputProps={{dir: 'ltr',maxLength: 15,className: userDetails.insuranceNo && (!/^\d+$/.test(userDetails.insuranceNo)) ? 'has-validation-error' : ''}} type="tel" variant="outlined" onChange={e => setUserDetails({...userDetails,insuranceNo: e.target.value})} value={userDetails.insuranceNo} /> : ''}
                            <TextField fullWidth sx={{mt: guildId && guildId != 64 ? 0 : 2,mb: 2.1}} label="توضیحات سفارش" multiline rows={3} variant="outlined" onChange={e => setUserDetails({...userDetails,description: e.target.value})} value={userDetails.description} />
                        </CardContent>
                    </Card></>}
                    <h3 className="others-page-title confirm-page-title">پرداخت و ثبت سفارش</h3>
                    <Card sx={{width: '100%',mb: 2}}>
                        <CardContent style={{paddingBottom: 10}}>
                            <Grid container spacing={2}>
                                <Grid item xs={7}>
                                    <TextField label="رمز یکبار مصرف" type="tel" className="ltr-input password-input" inputProps={{maxLength: 6}} variant="standard" fullWidth sx={{mb: 2.5,mt: 1}} onChange={e => setOtp(e.target.value)} value={otp} />
                                </Grid>
                                <Grid item xs={5}>
                                    <Button type="submit" isLoading={isLoading} fullWidth={true} sx={{mt: 1,py: 1.5}} className="custom-btn-primary" variant="contained" disabled={sentOtp || (userDetails.firstName && userDetails.firstName.length && !checkPersianCharacters(userDetails.firstName)) || (userDetails.lastName && userDetails.lastName.length && !checkPersianCharacters(userDetails.lastName)) || (userDetails.mobile && (!/^\d+$/.test(userDetails.mobile) || userDetails.mobile.length != 11)) || (userDetails.nationalCode && (!/^\d+$/.test(userDetails.nationalCode) || userDetails.nationalCode.length != 10))} onClick={sendOtp}>{sentOtp ? `${otpCounter} ثانیه` : btnText}</Button>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    {isFetchedData ? (!hasCredit ? <>
                        {hasCreditWithWallet && context.profile.roleId != 103 && context.walletPayment ? <>
                            <FormControlLabel sx={{mt: 1,mb: 2}} control={<Switch checked={useWallet} onChange={() => setUseWallet(!useWallet)} />} label={`به علت کافی نبودن موجودی کارتم، اجازه برداشت از کیف پولم به مبلغ ${new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(walletIncrease)} ریال را جهت ثبت این سفارش می دهم.`} />
                            <Button type="submit" isLoading={orderIsLoading} fullWidth={true} sx={{mt: 1,py: 1.5}} className="custom-btn-primary" color="success" variant="contained" onClick={submitOrder} disabled={!otp || otp.length != 6 || !useWallet}>پرداخت و ثبت سفارش</Button>
                        </> : <>
                        {context.profile.roleId != 103 && context.walletPayment ? <><Alert severity="info" sx={{mt: 2.5,mb: 1.5}}>موجودی کارت و کیف پول شما برای پرداخت این فاکتور به مبلغ {new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(totalPrice)} ریال کافی نمی باشد. لطفاً ابتدا کیف پول خود را به مبلغ {amount} ریال شارژ و سپس پرداخت کنید</Alert>
                        <Button fullWidth sx={{mt: 1,py: 1.5}} color="secondary" onClick={() => setOpenDeposit(true)} variant="contained" disabled={isLoading}>افزایش موجودی کیف پول</Button>
                        <Modal open={openDeposit} onClose={() => setOpenDeposit(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                            <Fade in={openDeposit}>
                                <Box sx={style}>
                                    <Typography variant="h6" component="h2" sx={{ fontSize: 18 }}>افزایش موجودی</Typography>
                                    <TextField type="tel" className="ltr-input" sx={{mb: 3,mt: 2}} fullWidth={true} inputProps={{maxLength: 12}} label="مبلغ" variant="standard" value={amount} onChange={e => setAmountValue(e.target.value)} />
                                    <Typography variant="subtitle2" component="span" className="choose-gateway-title">انتخاب درگاه پرداخت</Typography>
                                    <List component="nav">
                                        {gateways.map((gateway,index) => <ListItemButton key={gateway.id} selected={index == 0} onClick={() => setGatewayId(gateway.id)}>
                                            <img src={gateway.logo} width={60} style={{ marginLeft: 10 }} />
                                            <ListItemText>{gateway.title}</ListItemText>
                                            {gatewayId == gateway.id ? <ListItemIcon sx={{ minWidth: 'unset' }}>
                                                <CheckCircleOutline color="success" />
                                            </ListItemIcon> : ''}
                                        </ListItemButton>)}
                                    </List>
                                    <Button type="submit" isLoading={isLoading} fullWidth={true} sx={{mt: 1,py: 1.5}} className="custom-btn-primary" variant="contained" disabled={!amount || amount.length < 6 || amount.toString().replace(/,/g,'') < 10000 || checkPersianCharacters(userDetails.firstName) || checkPersianCharacters(userDetails.lastName) || (userDetails.mobile && (!/^\d+$/.test(userDetails.mobile) || userDetails.mobile.length != 11)) || (userDetails.nationalCode && (!/^\d+$/.test(userDetails.nationalCode) || userDetails.nationalCode.length != 10))} onClick={chargeDeposit}>پرداخت و افزایش موجودی</Button>
                                </Box>
                            </Fade>
                        </Modal></> : <Alert variant="standard" severity="info" color="info">موجودی شما برای ثبت این سفارش کافی نمی باشد</Alert>}
                        </>}
                    </> : <>
                        <Modal open={openRules} onClose={() => setOpenRules(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                            <Fade in={openRules}>
                                <Box sx={style}>
                                    <Typography variant="h6" component="h2" sx={{ fontSize: 18,mb: 2 }}>قوانین و مقررات خرید</Typography>
                                    <Typography variant="body2" textAlign="justify" lineHeight={2} component="p">{rules}</Typography>
                                    <Button type="submit" fullWidth={true} sx={{mt: 3,py: 1.5}} className="custom-btn-primary" variant="contained" onClick={() => {setOpenRules(false);setAcceptTerms(true)}}>متوجه شدم</Button>
                                </Box>
                            </Fade>
                        </Modal>
                        {rules && <FormControlLabel sx={{mt: 1,mb: 2}} control={<Switch checked={acceptTerms} onChange={() => setAcceptTerms(!acceptTerms)} />} label={<p><span style={{ color: 'red' }} onClick={() => setOpenRules(true)}>قوانین و مقررات</span> ثبت سفارش را می پذیرم</p>} />}
                        <Button type="submit" isLoading={orderIsLoading} fullWidth={true} sx={{mt: 1,py: 1.5}} className="custom-btn-primary" color="success" variant="contained" onClick={submitOrder} disabled={!otp || otp.length != 6 || !allowOrder || (rules && !acceptTerms)}>پرداخت و ثبت سفارش</Button>
                    </>) : ''}
                </Box>
            </div>
        </Grid>
    )
}

export default Confirm